import { useEffect } from 'react';
import { useRouter, useParams } from 'next/navigation';
import { API_BASE } from '@/lib/api';

/**
 * Legacy route — the undercard picks page collapsed into the event page
 * (`/events/main/[id]?week=N`). Old links, bookmarks, and JestSDK
 * notification deep links land here and get redirected to the week the
 * undercard maps to. Pages-router mirror of the webapp's server redirect:
 * a tiny on-mount fetch resolves the undercard's round, then replaces the
 * history entry so Back doesn't bounce through this stub.
 */
export default function LegacyUndercardRedirect() {
  const router = useRouter();
  const { id, undercardId } = useParams<{ id: string; undercardId: string }>();

  useEffect(() => {
    if (!id || !undercardId) return;
    let cancelled = false;
    (async () => {
      let target = `/events/main/${id}`;
      try {
        const res = await fetch(
          `${API_BASE}/api/main-events/${id}/undercards/${undercardId}`,
        );
        if (res.ok) {
          const undercard: { round?: number } = await res.json();
          if (typeof undercard.round === 'number') {
            target = `/events/main/${id}?week=${undercard.round}`;
          }
        }
      } catch {
        // Unresolvable undercard — fall through to the event page.
      }
      if (!cancelled) router.replace(target);
    })();
    return () => {
      cancelled = true;
    };
    // router identity changes every render (shim builds a fresh object) —
    // keying on the params alone keeps this a run-once-per-route effect.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, undercardId]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="w-12 h-12 border-4 border-gold border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
